import { render, staticRenderFns } from "./DialogPixBigValueDetails.vue?vue&type=template&id=268e13ba"
import script from "./DialogPixBigValueDetails.vue?vue&type=script&lang=js"
export * from "./DialogPixBigValueDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports